import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/workActivity';

const fetchWorkActivity = createAction('fetchWorkActivity');

function fetchWorkActivitySuccess(state, action) {
  const { workActivity } = action.payload;
  state.workActivity = workActivity;
  state.successFetching = true;
  state.errorFetching = false;
}

function fetchWorkActivityError(state) {
  state.workActivity = [];
  state.successFetching = false;
  state.errorFetching = true;
}

const workActivityReducer = createSlice({
  name: 'workActivity',
  initialState,
  reducers: {
    fetchWorkActivitySuccess,
    fetchWorkActivityError,
  },
});

export const workActivityActions = {
  ...workActivityReducer.actions,
  fetchWorkActivity,
};

export default workActivityReducer.reducer;
